<ng-container *ngIf="mode === 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>
    {{control?.value}}
</ng-template>
<ng-template #edit>

    <ng-select [appendTo]="appendTo" groupBy="categoryName" [searchFn]="searchFn" bindLabel="name" [items]="data$ | async" [placeholder]="placeholder" [searchable]="true" [formControl]="control" [multiple]="multiple" [hideSelected]="hideSelected">
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>